export type ButtonSizes = 'small' | 'default' | 'large';
export type ButtonVariants = 'default' | 'primary' | 'flat';
export type ButtonSizeMap<T> = {
  small: T;
  default: T;
  large: T;
};
export function getVariant(
  variant: ButtonVariants = 'default',
  disabled: boolean,
  destructive: boolean,
  contrast: boolean
): string {
  if (disabled) return 'disabled';

  if (contrast && destructive) {
    return `${variant}.contrastDestructive`;
  }

  if (contrast) {
    return `${variant}.contrast`;
  }

  if (destructive) {
    return `${variant}.destructive`;
  }

  return `${variant}.base`;
}
export function getFullWidthPropForContainer(fullWidth: boolean): any {
  return fullWidth
    ? {
        width: '100%',
      }
    : {
        alignSelf: 'center',
      };
}



// WEBPACK FOOTER //
// ../kibble/components/Button/utils.ts